import React from 'react';
// Let's create a simpler dialog without relying on shadcn/ui components
import { useNavigate } from 'react-router-dom';

const ProjectModal = ({ isOpen, onClose, project }) => {
  const navigate = useNavigate();

  if (!project) return null;

  const handleApplyClick = () => {
    navigate('/nv/sign-up');
  };

  // Function to split requirements into list items
  const formatRequirements = (reqText) => {
    if (!reqText) return [];
    return reqText.split(',').map(item => item.trim());
  };

  // Function to split side attractions into list items
  const formatSideAttractions = (sideText) => {
    if (!sideText) return [];
    return sideText.split(',').map(item => item.trim());
  };

  // If modal is not open, don't render anything
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-[500px] max-h-[90vh] overflow-y-auto">
        {/* Close button */}
        <div className="flex justify-end">
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-black"
          >
            ✕
          </button>
        </div>

        {/* Title */}
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold">{project.title}</h2>
        </div>

        {/* Content */}
        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-bold">Location:</h3>
            <p>{project.location}</p>
          </div>
          <div>
            <h3 className="text-xl font-bold">Project Description:</h3>
            <p className="text-sm leading-relaxed">{project.desc}</p>
          </div>
          <div>
            <h3 className="text-xl font-bold">Project Requirements:</h3>
            {project.req ? (
                <ul className="list-disc pl-6 space-y-1">
                {formatRequirements(project.req).map((req, index) => (
                    <li key={index}>{req}</li>
                ))}
                </ul>
            ) : (
                <p>Nil</p>
            )}
          </div>
          <div>
            <h3 className="text-xl font-bold">Side Attractions:</h3>
            <ul className="list-disc pl-6 space-y-1">
              {formatSideAttractions(project.side).map((side, index) => (
                <li key={index}>{side}</li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-bold">Working Hours:</h3>
            <p>{project.hours}</p>
          </div>
          <div>
            <h3 className="text-xl font-bold">Duration:</h3>
            <p>{project.duration}</p>
          </div>
        </div>

        {/* Apply button */}
        <div className="mt-6 flex justify-center">
          <div 
            onClick={handleApplyClick}
            className="bg-[#08841B] text-white px-4 py-2 rounded-md cursor-pointer hover:bg-[#06660F] transition-colors"
          >
            Apply Now
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;